import { Route } from '@angular/router';
import { ResearchComponent } from 'app/modules/research/research.component';
import { ResearchListComponent } from 'app/modules/research/list/list.component';
import { ResearchDetailsComponent } from 'app/modules/research/details/details.component';
import {
  PipelinesResolver,
  ProjectDataResolver,
  ProjectsFieldDefsResolver,
} from 'app/modules/projects/projects.resolvers';
import { ResearchDataResolver, ResearchParcelResolver } from './research.resolvers';

export const researchRoutes: Route[] = [
  {
    path: '',
    component: ResearchComponent,
    resolve: {
      research_options: ResearchDataResolver,
      fieldDefs: ProjectsFieldDefsResolver,
      options: ProjectDataResolver,
    },
    children: [
      {
        path: '',
        component: ResearchListComponent,
        resolve: {
          research_options: ResearchDataResolver,
          fieldDefs: ProjectsFieldDefsResolver,
          options: ProjectDataResolver,
        },
      },
      {
        path: 'currentLocation',
        redirectTo: '/research?getLocation=true',
      },
      {
        path: ':id',
        component: ResearchDetailsComponent,
        resolve: {
          research_options: ResearchDataResolver,
          fieldDefs: ProjectsFieldDefsResolver,
          parcel: ResearchParcelResolver,
          pipelines: PipelinesResolver,
          options: ProjectDataResolver,
        },
      },
    ],
  },
];
